export default "__VITE_ASSET__DDGwtaYT__"